import styled from '@emotion/styled'
import { Table } from 'react-bootstrap'

export const SummarySheet = styled('div')`
  label: SummarySheet;
  max-width: 720px;
  margin: 0 auto;
  padding: 15px;
`

export const SummaryHeaderBlock = styled('div')`
  label: HeaderBlock;
  color: ${(props) => props.theme.colors.primary};
  font-size: 19px;
`

export const SummaryTable = styled(Table)`
  color: #000;
  label: SummaryTable;
  font-size: 12px;
  margin-top: 4px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  td {
    position: relative;
    small {
      position: absolute;
      top: 0px;
      font-size: 7px;
      font-weight: bold;
    }
  }
  th {
    font-weight: 800;
  }
  > thead > tr > th {
    border-color: inherit;
    color: #000;
    text-align: center;
    background-color: ${(props) => props.theme.colors.secondary};
  }
  td {
    border-left: 0;
  }
  tr > td:last-child {
    border-right: 0;
  }
  tr:last-child > td {
    border-bottom: 0;
  }
  td:nth-of-type(2) {
    text-align: right;
  }
  li {
    font-size: 10px;
    a {
      text-decoration: underline;
      color: #000;
    }
  }
  th,
  td {
    padding: 3px;
  }
`
export const SummaryTableHeader = styled('tr')`
  label: SummaryTableHeader;
  color: ${(props) => props.theme.colors.primary};
  font-size: 18px;
  line-height: 12px;
  position: relative;
  > td > small {
    font-size: 11px;
  }
  td > span {
    font-size: 10px;
  }

  li {
    color: #000;
  }
`
export const BoldText = styled('b')`
  label: BoldText;
  font-size: 21px;
`
export const PdfTitle = styled('div')`
  label: pdfTitle;
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
`
export const PdfLogo = styled('img')`
  label: pdfLogo;
  height: 54px;
  margin-bottom: 10px;
`
export const PdfTnC = styled('p')`
  label: PdfTnC;
  color: #666;
  font-size: 14px;
`

export const InfoSection = styled('div')`
  label: InfoSection;
  font-size: 10px;
`
